<template>
  <div>
    <direct-required-modal
    :directId="directId"
    @refresh="getData"
    ref="directRequiredModal" />
    
    <vx-card :id="cardId" class="vs-con-loading__container">
      <card-header :title="$t(cardTitle)" v-model="params.search" @search="search" @close="close"/>
      <direct-required-table
        :data="data"
        @openModal="openModal"
        @loadMore="loadMore"
        @search="search"
      />
    </vx-card>
  </div>
</template>



<script>
import DirectRequiredTable from '../tables/DirectRequiredTable.vue'
import DirectRequiredModal from '../components/DirectRequiredModal.vue'

import CardHeader from '../components/CardHeader.vue'
import dashboard from '@/http/requests/dashboard'

export default {
  name: 'direct-required-card',
  components: {
    DirectRequiredTable,
    DirectRequiredModal,
    CardHeader,
  },
  props: {
    // statusId: {
    //   type: [String, Number],
    //   required: true,
    // },
  },
  data() {
    return {
      cardTitle: 'direct_required',
      cardId:'loading-direct-required-card',
      directId:'',
      data: [],
      lastPage: 1,
      loading: false,
      params: {
        page: 1,
        search: '',
      },
    }
  },
  methods: {
    getData() {
      this.loading = true
      window.scrollTo(0,document.body.scrollHeight);
      dashboard
        .directList(this.params)
        .then((response) => {
          if (this.params.page === 1) {
            this.data = [...response.data.data]
          } else {
            this.data = [...this.data, ...response.data.data]
          }
          this.lastPage = response.data.last_page
          this.loading = false
        })
        .catch((response) => {
          this.showValidationErrors(response)
          this.loading = false
        })
    },
    loadMore() {
      if (this.params.page >= this.lastPage) {
        return
      }
      this.params.page++
      this.getData  ()
    },
    search() {
      this.params.page = 1
      this.getData()
    },
    openModal(e){
      this.directId = e
      this.$refs.directRequiredModal.open()
    },
    close() {
      this.$emit('close')
    },
  },
  mounted() {
    this.getData()
  },
  watch: {
    loading(val) {
      if (val) {
        this.$vs.loading({
          container: `#${this.cardId}`,
          scale: 0.45,
        })
      } else {
        this.$vs.loading.close(`#${this.cardId} > .con-vs-loading`)
      }
    }
  },
}
</script>

